<template>
    <div>
        <pagamento :pagamento="pagamento">
            <template slot="footer">
                <app-btn-voltar></app-btn-voltar>
            </template>
        </pagamento>
        <consultorias
            :consultorias="consultoriasDisponiveis"
            :incluirSelecao="true"
            titulo="CONSULTORIAS DISPONÍVEIS"
        >
            <template slot="botoes">
                <b-button-group class="float-right">
                    <b-button
                        variant="primary"
                        @click="confirmaAssociarSelecionadas()"
                        :disabled="
                            consultoriasDisponiveisSelecionadas.length === 0
                        "
                        ><i class="fa fa-plus"></i> Associar
                        selecionadas</b-button
                    >
                </b-button-group>
            </template>
            <template slot="consultoriaSelecao" slot-scope="data">
                <b-form-checkbox
                    :value="data.consultoriaId"
                    v-model="consultoriasDisponiveisSelecionadas"
                ></b-form-checkbox>
            </template>
        </consultorias>
    </div>
</template>

<script>
import Pagamento from './PagamentoDetalhar'
import Consultorias from '../consultorias/Consultorias2'

export default {
    props: {
        pagamentosServicos: {
            type: Object,
            default: () => ({})
        },

        pagamento: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            consultoriasDisponiveisSelecionadas: [],
            consultoriasDisponiveis: []
        }
    },

    methods: {
        obterConsultoriasDisponiveis() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .obterConsultoriasDisponiveis(this.$route.params.pagamentoId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.consultoriasDisponiveis = response.data
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        confirmaAssociarSelecionadas() {
            this.$swal({
                title: 'Associação de Consultorias',
                html: `Confirma a associação das consultorias selecionadas?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.associar()
                }
            })
        },

        associar() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .associarConsultorias({
                    pagamentoId: this.$route.params.pagamentoId,
                    consultoriasId: this.consultoriasDisponiveisSelecionadas
                })
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro salvo com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.consultoriasDisponiveisSelecionadas = []
                            this.obterConsultoriasDisponiveis()
                            this.$emit('obterPagamentoAtualizado')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    created() {
        this.obterConsultoriasDisponiveis()
    },

    components: {
        Consultorias,
        Pagamento
    }
}
</script>
